import { cn } from '../../lib/cn';
import type { BriefingRow } from '../../mobilecompanion/framework';

type Props = { briefings?: BriefingRow[] };

export function MobileAIBriefingsPanel({ briefings = [] }: Props) {
  return (
    <div className="space-y-2">
      {briefings.map((b) => (
        <div key={b.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{b.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{b.type} · {b.duration}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            b.status === 'ready' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            b.status === 'available' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {b.status}
          </span>
        </div>
      ))}
    </div>
  );
}
